import { ReactNode } from 'react';

import { usePermissionsContext } from '../context/permissionsContext';
import { getPendingTermsType } from '../stores/schemas/userMe';

import { TermsAcceptanceModal } from './TermsAcceptanceModal';

const AppGates = ({ children }: { children: ReactNode }) => {
  const { userData } = usePermissionsContext();
  const termsType = getPendingTermsType(userData);

  return (
    <>
      {children}
      {!!termsType && <TermsAcceptanceModal open termsType={termsType} />}
    </>
  );
};

export { AppGates };
